import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
// import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Button from "@mui/material/Button";
import {  
  Grid,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import "./styles/Dac.css";
import { useDispatch, useSelector } from "react-redux";
import { saveDacRequest } from "../../../../../../redux/actions/adminAccount-actions/dac-actions";
import { TextFieldInput } from "../../../../../../components/common/TextFieldInput";
import {
  getAllVvmcApplicationRole,
  getAllVvmcDocumentTypes
} from "../../../../../../redux/actions/adminAccount-actions/dac-actions";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "80%",
  border: 0,
  borderRadius: "10px",
  backgroundColor: "white",
  outline: "none",
  overflow: "hidden"
};

const DacModal = ({
  isModalOpen,
  toggleOpenDacModal,
  rowData,
  isEditRequest
}) => {
  const dispatch = useDispatch();
  const [dacName, setDacName] = useState("");
  const [description, setDescription] = useState("");
  const [vvmcApplicationRoleApplicationRoleId, setRoleID] = useState("");  
  const [docType, setDocType] = useState("");   
  const [editDocId, setEditDocId] = useState(true);
  const [editVvmcRoleId, setEditVvmcRoleId] = useState(true);  
  const [isSaveDisabled, setSaveDisabled] = useState(true); 
  const { allVvmcRoles, allVvmcDocTypeGroups } = useSelector((state) => ({      
    allVvmcRoles: state.DacReducer.allVvmcRoles,
    // allVvmcRolesError: state.DacReducer.allVvmcRolesError,
    allVvmcDocTypeGroups: state.DacReducer.allVvmcDocTypeGroups
    // allVvmcDocTypeGroupsError: state.DacReducer.allVvmcDocTypeGroupsError
  }));

  let VVMC_APPLICATION_ROLES = [];
  let VVMC_DOCUMENT_TYPE_GROUPS = [];

  console.log("isEditRequest", isEditRequest);

  useEffect(() => {
    if (isEditRequest) {
      setDacName(rowData?.name);
      setDescription(rowData?.description);
      setRoleID(rowData?.vvmcApplicationRoleApplicationRoleId);
      setDocType(rowData?.vvmcDocumentTypeGroupDocTypeGroupId); 
      setEditDocId(false);
      setSaveDisabled(false);               
      setEditVvmcRoleId(false);            
    } else {      
      setEditDocId(true);
      setEditVvmcRoleId(true);    
      setSaveDisabled(true);                  
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditRequest]);

  useEffect(() => {
      if (                
        (!isEditRequest && dacName?.length > 0 && vvmcApplicationRoleApplicationRoleId && docType) || 
        (isEditRequest && dacName?.length > 0 && vvmcApplicationRoleApplicationRoleId && docType)    
      ) {        
        setSaveDisabled(false);
      } else {
        setSaveDisabled(true);
      }
  }, [    
    dacName,
    vvmcApplicationRoleApplicationRoleId,
    docType,    
    isEditRequest    
  ]);

  const onSaveHandler = () => {
    const data = { 
      name: dacName,
      description: description,
      vvmcApplicationRoleApplicationRoleId:vvmcApplicationRoleApplicationRoleId,
      vvmcDocumentTypeGroupDocTypeGroupId: docType
    };
    dispatch(saveDacRequest(data, isEditRequest, rowData?.id));
    handleClose();
  };

  const handleClose = () => {
    toggleOpenDacModal();
    clearState();                   
  };

  const clearState = () => {
    setDacName("");
    setDescription("");
    setRoleID("");
    setDocType(""); 
    setSaveDisabled(true);         
  };

  useEffect(() => {
    dispatch(getAllVvmcApplicationRole());
    dispatch(getAllVvmcDocumentTypes());
  }, [dispatch]);

  const handleDocIdEdit = () => {
    setEditDocId(true);    
  };

  const handleRoleIdEdit = () => {  
    setEditVvmcRoleId(true);
  };

if(allVvmcRoles && Array.isArray(allVvmcRoles) && allVvmcRoles.length > 0){ {
  allVvmcRoles.map((role) => {
    let roleId = role.application_role_id;
    let displayName = `${role.application_role_name} - ${role.application_role_id}`;

    const vvmcRoleDropDown = {
      id : roleId,
      name : displayName
    };
    VVMC_APPLICATION_ROLES.push(vvmcRoleDropDown);
  });
  }
}

if(allVvmcDocTypeGroups && Array.isArray(allVvmcDocTypeGroups) && allVvmcDocTypeGroups.length > 0){ {
  allVvmcDocTypeGroups.map((doc) => {
    let docId = doc.doc_type_group_id;
    let displayName = `${doc.doc_type_group_name} - ${doc.doc_type_group_id}`;

    const vvmcDocTypeDropDown = {
      id : docId,
      name : displayName
    };
    VVMC_DOCUMENT_TYPE_GROUPS.push(vvmcDocTypeDropDown);
  });
  }
}

  return (
    <Modal
      className="dacModalParent"
      open={isModalOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="fitermodel-dac" style={ModalStyle}>
        <div className="filterContent">         
          <div
            className="filterContentHeader"
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingRight: "15px"
            }}
          >
            <div> {isEditRequest ? "Edit DAC Role" : "Add DAC Role"}</div>
            <HighlightOffIcon
              sx={{
                mr: "5px",
                "&:hover": {
                  color: "gray",
                  transition: "color 0.2s"
                }
              }}
              onClick={handleClose}
            />
          </div>
                    
            <Grid container className="dacModalContent">
            {isEditRequest ? (
              <Grid item sm={12}>
                <div className="">
                <span className="DacdangerColor">* </span>
                <span className="DacdangerColor">
                      <em>
                        {
                          "Please ensure to click Edit icon and then update/Edit  Document Type and Application Role ID"
                        }
                      </em>
                </span>
                </div>
              </Grid>  
        ) : <div className="">
                <span className="DacdangerColor">* </span>
                <span className="DacdangerColor">
                      <em>
                        {
                          "Marked fields are mandatory"
                        }
                      </em>
                </span>
                </div> }
        
              <Grid item sm={12}>
                <div className="DacModalTitle">                 
                    <span>DAC Role Name </span>
                    <span className="DacdangerColor">*</span>
                </div>
              </Grid>                                   

              <Grid item sm={11}>
                <TextFieldInput
                  placeholder="Enter DAC Role Name"
                  value={dacName}
                  className="DacText"
                  onChange={(e) => {
                    setDacName(e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <div className="DacModalTitle">
                  <span>
                    <span>Description</span>
                  </span>
                </div>
              </Grid>
              <Grid item sm={11}>               
                <TextFieldInput
                  isMultiple={true}
                  rows={2}
                  placeholder="Enter Description"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                />
              </Grid>                                                     

            <Grid container spacing={2} sx={{mt:"1px"}}>
              <Grid item sm={8}>
                <FormControl fullWidth 
                sx={
                      !editVvmcRoleId
                        ? {                                                                                   
                            borderRadius: "5px",
                            boxShadow: 0,
                            backgroundColor: "#c4bebe6b"
                          }
                        : {                                                                                   
                            borderRadius: "5px",
                            boxShadow: 0
                          }
                    }>
                  <InputLabel htmlFor="demo-customized-select-native" id="demo-simple-select-label"><span className="DropdownTitle"> VVMC Application Role </span> <span className="DacdangerColor">*</span></InputLabel>
                  <Select       
                    label="VVMC Application Role *"                                 
                    value={vvmcApplicationRoleApplicationRoleId}                    
                    disabled={!editVvmcRoleId}                                      
                    onChange={(e) => {
                        setRoleID(e.target.value);                        
                      }}
                     onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          setRoleID(e.target.value);                                                                          
                        }
                      }}
                  >
                    { VVMC_APPLICATION_ROLES.map((role) => ( 
                      <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                    ))}                    
                  </Select>
                </FormControl>                   
              </Grid>  
              <Grid item sm={4}>      
                  {isEditRequest && (
                    <Tooltip title="Edit VVMC Application Role"  placement="right" arrow>
                      <EditOutlinedIcon
                      className="clickable"                    
                      sx={{
                        ":hover": {
                          cursor: "pointer"
                        },
                        verticalAlign: "middle",
                        height: "35px"
                      }}
                      onClick={handleRoleIdEdit}
                    />
                    </Tooltip>
                  )
                  }                                      
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{mt:1}}>
              <Grid item sm={8}>
                <FormControl fullWidth 
                sx={
                      !editDocId
                        ? {                                                                                  
                            borderRadius: "5px",
                            boxShadow: 0,
                            backgroundColor: "#c4bebe6b"
                          }
                        : {                                                                                  
                            borderRadius: "5px",
                            boxShadow: 0
                          }
                    }>
                  <InputLabel  htmlFor="demo-customized-select-native" id="demo-simple-select-label"><span className="DropdownTitle"> VVMC Document Type </span> <span className="DacdangerColor">*</span></InputLabel>
                  <Select                                        
                    value={docType}
                    label="VVMC Document Type *"  
                    disabled={!editDocId}                  
                    onChange={(e) => {
                        setDocType(e.target.value);                        
                      }}
                     onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          setDocType(e.target.value);                                                                          
                        }
                      }}
                  >
                    { VVMC_DOCUMENT_TYPE_GROUPS.map((doc) => ( 
                      <MenuItem key={doc.id} value={doc.id}>{doc.name}</MenuItem>
                    ))}                    
                  </Select>
                </FormControl>                   
              </Grid>  
              <Grid item sm={4}>      
                  {isEditRequest && (
                    <Tooltip title="Edit VVMC Document Type"  placement="right" arrow>
                      <EditOutlinedIcon
                      className="clickable"                    
                      sx={{
                        ":hover": {
                          cursor: "pointer"
                        },
                        verticalAlign: "middle",
                        height: "35px"
                      }}
                      onClick={handleDocIdEdit}
                    />
                    </Tooltip>
                  )
                  }                                      
              </Grid>
            </Grid>

            </Grid>          
        </div>

        <div className="summaryModalButtons" style={{ marginTop: "25px" }}>
          <Button
            className="buttonDanger"
            variant="outlined"
            onClick={handleClose}
            color="error"
            sx={{
              width: 100,
              height: 35,
              fontSize: 12,
              ":hover": {
                bgcolor: "red",
                color: "white"
              }
            }}
          >
            Cancel
          </Button>
          <Button
            className="buttonSuccess"
            variant="outlined"
            disabled={isSaveDisabled}
            onClick={onSaveHandler}
            color="success"
            sx={{
              width: 100,
              height: 35,
              fontSize: 12,
              ":hover": {
                bgcolor: "green",
                color: "white"
              }
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DacModal;
